import React, { useContext, useEffect, useState } from "react";

// context
import { SecondInputFormDataContext } from "../../../context/SecondInputFormDataContext";

// style
import Style from "./TotalExpenseWarning.module.css";

const TotalExpenseWarning = ({ hideFESBValueWarning = false }) => {
  const [showWarningFESBValue, setShowWarningFESBValue] = useState(false);
  const [showWarningTotalValue, setShowWarningTotalValue] = useState(false);

  const warningMessageFESBValuePart =
    "Zbroj troškova je veći od dijela proračuna koji FESB pokriva!";

  const warningMessageTotalProjectValue =
    "Zbroj troškova je veći od ukupne vrijednosti projekta!";

  const { totalExpense, fesbValuePart, totalValue, calculatedFesbValuePart } =
    useContext(SecondInputFormDataContext);

  useEffect(() => {
    if (calculatedFesbValuePart > fesbValuePart) {
      setShowWarningFESBValue(true);
    } else {
      setShowWarningFESBValue(false);
    }

    if (totalExpense > totalValue) {
      setShowWarningTotalValue(true);
    } else {
      setShowWarningTotalValue(false);
    }
  }, [totalExpense, fesbValuePart, totalValue]);

  return (
    <div>
      {showWarningFESBValue && !hideFESBValueWarning && (
        <div className={Style.WarningMessage}>
          {warningMessageFESBValuePart}
        </div>
      )}
      {showWarningTotalValue && (
        <div className={Style.WarningMessage}>
          {warningMessageTotalProjectValue}
        </div>
      )}
    </div>
  );
};

export default TotalExpenseWarning;
